import script from "./DrawdownChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawdownChart.vue?vue&type=script&setup=true&lang=ts"

import "./DrawdownChart.vue?vue&type=style&index=0&id=63bced08&lang=css"

const __exports__ = script;

export default __exports__